import { Component } from '@angular/core';
import { Helpers } from 'src/app/core/helpers';
@Component({
	selector: 'app-faqs',
	templateUrl: './faqs.component.html',
	styleUrl: './faqs.component.less'
})
export class FaqsComponent {
	Helper = Helpers

}
